    async function returnCart() {
  const res = await fetch('/cart.js');
  const cart = await res.json();

  return cart.items;
}

if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
    }



    async onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];
      let formData = new FormData(this.form);


      if (this.cart) {
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }
      
if(getCookie("offre")=="offert" && window.active && window.arrayOffre.find((e)=> e == this.form.id.value) ){
      formData.append('items[0][id]', window.arrayOffert[window.arrayOffre.findIndex((e)=> e == this.form.id.value)%10]);
formData.append('items[0][quantity]', 1);
}



     else if(getCookie("offre") == "offert" && window.arrayOffreAdo.find((e)=> e == this.form.id.value)){
        var idx = ((window.arrayOffreAdo.findIndex((e)=> e == this.form.id.value)%5 - 1)>=0)?(window.arrayOffreAdo.findIndex((e)=> e == this.form.id.value)%5 - 1):0
         formData.append('items[0][id]', window.arrayOffert[idx]);
formData.append('items[0][quantity]', 1);
      }

  
                    else if(getCookie("offre")=="bf" && window.arrayOffre.find((e)=> e == this.form.id.value) ){

                 if ( (window.arrayOffre.findIndex((e)=> e == this.form.id.value)%10)){
      formData.append('items[0][id]', window.arrayBF[window.arrayOffre.findIndex((e)=> e == this.form.id.value)%10]);
                   formData.append('items[0][quantity]', 1);
                 }
                
                

}



     else if(getCookie("offre") == "bf" && window.arrayOffreAdo.find((e)=> e == this.form.id.value)){
        var idx = ((window.arrayOffreAdo.findIndex((e)=> e == this.form.id.value)%5 - 1)>=0)?(window.arrayOffreAdo.findIndex((e)=> e == this.form.id.value)%5 - 1):0



       if (idx != 1){
         formData.append('items[0][id]', window.arrayBF[idx]);
                  
formData.append('items[0][quantity]', 1);
       }
      

      }





              else if(getCookie("offre")=="cadeau" && window.active && window.arrayOffre.find((e)=> e == this.form.id.value) ){
                 
                 if ( (window.arrayOffre.findIndex((e)=> e == this.form.id.value)%10) != 1){
      formData.append('items[0][id]', window.arrayCadeau[window.arrayOffre.findIndex((e)=> e == this.form.id.value)%10]);
                   formData.append('items[0][quantity]', 1);
                 }
                

}



     else if(getCookie("offre") == "cadeau" && window.arrayOffreAdo.find((e)=> e == this.form.id.value)){
        var idx = ((window.arrayOffreAdo.findIndex((e)=> e == this.form.id.value)%5 - 1)>=0)?(window.arrayOffreAdo.findIndex((e)=> e == this.form.id.value)%5 - 1):0

       if (idx != 1){
         formData.append('items[0][id]', window.arrayCadeau[idx]);
                  
formData.append('items[0][quantity]', 1);
       }

      }

           else if(getCookie("offre")=="mystery" && window.active && window.arrayOffre.find((e)=> e == this.form.id.value) ){
      formData.append('items[0][id]', window.arrayMystery[window.arrayOffre.findIndex((e)=> e == this.form.id.value)%10]);
formData.append('items[0][quantity]', 1);
}

  else if(getCookie("offre") == "mystery" && window.arrayOffreAdo.find((e)=> e == this.form.id.value)){
        var idx = ((window.arrayOffreAdo.findIndex((e)=> e == this.form.id.value)%5 - 1)>=0)?(window.arrayOffreAdo.findIndex((e)=> e == this.form.id.value)%5 - 1):0
         formData.append('items[0][id]', window.arrayMystery[idx]);
formData.append('items[0][quantity]', 1);
      }


    
      config.body = formData;
      
  
  fetch(window.Shopify.routes.root + 'cart.js', config) .then((response) => response.json())
        .then((response) => {
 


      fetch(window.Shopify.routes.root + 'cart/add.js', config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }

          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => { this.cart.renderContents(response) });
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            this.cart.renderContents(response);
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
        })

    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}
